import format from 'date-fns/format';

type LeadHeaderTimestampsProps = {
  createdAt?: string | null;
  updatedAt?: string | null;
};

function formatLeadTimestamp(value?: string | null) {
  if (!value) {
    return null;
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return `${format(date, 'do MMM yyyy')} at ${format(date, 'p')}`;
}

export default function LeadHeaderTimestamps({
  createdAt,
  updatedAt,
}: LeadHeaderTimestampsProps) {
  const created = formatLeadTimestamp(createdAt);
  const updated = formatLeadTimestamp(updatedAt);

  if (!created && !updated) {
    return null;
  }

  return (
    <p className="text-xs text-gray-500">
      {created ? (
        <>
          Created <time dateTime={createdAt || undefined}>{created}</time>
        </>
      ) : null}
      {created && updated ? (
        <span className="text-gray-300" aria-hidden="true">
          {' '}
          ·{' '}
        </span>
      ) : null}
      {updated ? (
        <>
          Updated <time dateTime={updatedAt || undefined}>{updated}</time>
        </>
      ) : null}
    </p>
  );
}
